import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircle, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Extract the ?credits= from query param
  const creditsAdded = new URLSearchParams(location.search).get("credits");

  // Refresh the user's credits on mount
  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-green-100 to-white">
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-md text-center">
        <CheckCircle className="text-green-500 w-16 h-16 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-green-700 mb-2">
          Payment Successful!
        </h2>
        <p className="text-gray-700 mb-4">
          {creditsAdded
            ? `✅ ${creditsAdded} credits have been added to your account.`
            : user
            ? `You now have ${user.credits} credits in your account.`
            : "Credits have been added to your account."}
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-bold"
          >
            Go to Dashboard <ArrowRight className="w-4 h-4" />
          </button>
          <button
            onClick={() => navigate("/search")}
            className="flex items-center justify-center gap-2 text-blue-700 hover:underline text-sm"
          >
            Start a New Search
          </button>
        </div>
      </div>
    </div>
  );
}
